<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form ref="MandatureForm" @submit="AddPartenaire" :validation-schema="PartenaireSchema">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Nom du Partenaire<span class="text-danger">*</span>
                            </label>
                            <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrez un libellé" />
                            <ErrorMessage name="nom" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Logo du Partenaire <span class="text-danger">*</span>
                            </label>
                            <Field name="urlImage" type="file" class="form-control shadow-none fs-md-15 text-black"
                                @change="onFileChange" />
                            <ErrorMessage name="urlImage" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button class="default-btn me-20 transition border-0 fw-medium text-white pt-10 
                  pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit">
                                Ajouter
                            </button>
                            <router-link to="/liste-partenaire"
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                                    class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler</router-link>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { error, success } from "../../utils/utils";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { AlaUne } from "../../models/AlaUne";
import * as Yup from "yup";
import axios from "axios";
import { Mandature } from "@/models/postemembremandature";
import Swal from "sweetalert2";
import { Partenaires } from "@/models/Partenaire";

export default defineComponent({
    name: "AddPartenaire",
    components: {
        Form,
        Field,
        ErrorMessage,
    },

    setup: () => {
        const PartenaireSchema = Yup.object().shape({
            nom: Yup.string().required("Le nom du partenaire est obligatoire"),
            urlImage: Yup.string().required("L'image est obligatoire"),

        });

        const PartenaireForm = ref<Partenaires | null>(null);
        const router = useRouter();
        const selectedFile = ref<File | null>(null);

        const onFileChange = (event: Event) => {
            const target = event.target as HTMLInputElement;
            if (target.files && target.files[0]) {
                selectedFile.value = target.files[0];
            }
        };

        onMounted(() => {
            //
        })

        const AddPartenaire = async (values, { resetForm }) => {
            try {
                const formData = new FormData();
                formData.append("nom", values.nom);
                if (selectedFile.value) {
                    formData.append("urlImage", selectedFile.value);
                }
                const response = await ApiService.postWithFile("/partenaire", formData);
                Swal.fire({
                    title: "Partenaire crée avec succès",
                    icon: "success",
                    draggable: true,
                    confirmButtonText: "OK",
                    timer: 1500
                }).then(() => {
                    resetForm();
                    router.push("/liste-partenaire")
                });
                console.log("Partenaire ajouté avec succès:", response.data);
            } catch (error) {
                console.error("Erreur lors de l’envoi :", error);
                Swal.fire({
                    title: "Erreur lors de l'ajout du partenaire",
                    icon: "error",
                    draggable: true,
                });
            }
        };

        return {
            AddPartenaire,
            PartenaireSchema,
            PartenaireForm,
            onFileChange
        };
    },
});
</script>
